import { useState, useEffect } from "react";
import api from "../services/api";
import ApoieButton from "../components/ApoieButton/ApoieButton";
import PageHero from "../components/PageHero/PageHero";
import heroFallbackUrl from "../assets/images/metodologia-hero-shaped.png";
import Intro from "../components/Metodologia/Intro/Intro";
import Peads from "../components/Metodologia/Peads/Peads";
import Cycles from "../components/Metodologia/Cycles/Cycles";
import Oficinas from "../components/Metodologia/Oficinas/Oficinas";
import FormActions from "../components/Admin/FormActions/FormActions";
import { useIsAdmin } from "../hooks/useIsAdmin";
import { useAdminPage } from "../hooks/useAdminPage";
import "./Metodologia.css";

export default function Metodologia() {
  const [data, setData] = useState(null);
  const { isAdmin, isChecking } = useIsAdmin();
  const adminPage = useAdminPage();
  const [isEditing, setIsEditing] = useState(false);
  const [draft, setDraft] = useState(null);
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState("");

  useEffect(() => {
    api
      .get("/metodologia")
      .then((res) => setData(res.data))
      .catch(() => setData(null));
  }, []);

  const removerImagemAntiga = (imagemAntiga, imagemNova) => {
    const publicIdAntigo = imagemAntiga?.public_id;
    const publicIdNovo = imagemNova?.public_id;

    if (publicIdAntigo && publicIdAntigo !== publicIdNovo) {
      api
        .delete("/media/remove", { data: { public_id: publicIdAntigo } })
        .catch((error) => {
          console.error("Falha ao remover imagem antiga", error);
        });
    }
  };

  const handleSalvar = async () => {
    setSaving(true);
    setSaveError("");

    try {
      const payload = {
        intro: draft.intro,
        introduction: draft.introduction,
        peads: draft.peads,
        cycles: draft.cycles,
        workshops: draft.workshops,
      };

      const response = await api.put("/metodologia/admin/conteudo", payload);

      removerImagemAntiga(
        data?.introduction?.image,
        draft?.introduction?.image,
      );

      const itensAntigos = data?.workshops?.items || [];
      const itensNovos = draft?.workshops?.items || [];
      itensNovos.forEach((item, index) => {
        removerImagemAntiga(itensAntigos[index]?.image, item?.image);
      });

      setData(response.data);
      setIsEditing(false);
      setDraft(null);
    } catch (error) {
      setSaveError(
        error?.response?.data?.message ||
          "Não foi possível salvar. Verifique os campos e tente novamente.",
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="metodologia-page">
      {adminPage ? (
        <header className="admin-metodologia__header">
          <h1>EDITAR SEÇÃO</h1>
          <p>Metodologia</p>
        </header>
      ) : (
        <PageHero
          imageUrl={heroFallbackUrl}
          imageShape="provided"
          title="Metodologia"
        />
      )}

      {!adminPage && <ApoieButton />}

      <Intro
        text={isEditing ? draft?.intro : data?.intro}
        section={isEditing ? draft?.introduction : data?.introduction}
        isEditing={isEditing}
        onChange={(value) => setDraft((prev) => ({ ...prev, intro: value }))}
        onSectionChange={(field, value) => {
          setDraft((prev) => ({
            ...prev,
            introduction: { ...prev.introduction, [field]: value },
          }));
        }}
      />

      <Peads
        section={isEditing ? draft?.peads : data?.peads}
        isEditing={isEditing}
        onChange={(field, value) => {
          setDraft((prev) => ({
            ...prev,
            peads: { ...prev.peads, [field]: value },
          }));
        }}
      />

      <Cycles
        section={isEditing ? draft?.cycles : data?.cycles}
        isEditing={isEditing}
        onChange={(field, value) => {
          setDraft((prev) => ({
            ...prev,
            cycles: { ...prev.cycles, [field]: value },
          }));
        }}
      />

      <Oficinas
        title={isEditing ? draft?.workshops?.title : data?.workshops?.title}
        text={isEditing ? draft?.workshops?.text : data?.workshops?.text}
        items={isEditing ? draft?.workshops?.items : data?.workshops?.items}
        isEditing={isEditing}
        onChange={(field, value) => {
          setDraft((prev) => ({
            ...prev,
            workshops: { ...prev.workshops, [field]: value },
          }));
        }}
        onItemsChange={(items) => {
          setDraft((prev) => ({
            ...prev,
            workshops: { ...prev.workshops, items },
          }));
        }}
      />

      {!isChecking && isAdmin && adminPage && (
        <>
          {saveError && <p className="metodologia-page__erro">{saveError}</p>}
          <FormActions
            editing={isEditing}
            onEdit={() => {
              setIsEditing(true);
              setDraft(data);
            }}
            onCancel={() => {
              setIsEditing(false);
              setDraft(null);
            }}
            onSave={handleSalvar}
            saving={saving}
          />
        </>
      )}
    </div>
  );
}
